export default "__VITE_ASSET__MfOXyHIF__"